export default "__VITE_ASSET__e8f3d87a__"